<p>config-panel works!</p>
